import { Combobox } from '@library/components/selects';
import type { ComboboxOption } from '@library/components/selects/combobox/Combobox';
import { useMemo } from 'react';
import { useUnsettlementsReasons } from '@bo-hooks/unsettlements/useUnsettlementsReasons';

interface ReasonCodeSelectProps {
  onChange: (selectedOption: ComboboxOption<string | number> | null) => void;
  unsettlementReason: ComboboxOption<string | number> | null;
}

export const ReasonCodeSelect = ({
  onChange,
  unsettlementReason
}: ReasonCodeSelectProps) => {
  const { data: unsettlementsReasonsData = [] } = useUnsettlementsReasons();

  const reasonOptions = useMemo(
    () =>
      unsettlementsReasonsData.map((reason) => ({
        label: reason,
        value: reason
      })),
    [unsettlementsReasonsData]
  );

  return (
    <div>
      <p className="text-soClean-180 mb-1 text-sm">
        Reason code
        <span className="text-stankonia-100">*</span>
      </p>
      <Combobox
        closeMenuOnSelect
        id="reasonCode"
        isClearable={false}
        isMulti={false}
        onChange={onChange}
        options={reasonOptions}
        value={unsettlementReason}
      />
    </div>
  );
};
